<template>
  <div class="prontuario-medico-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form group-label="Prontuário">
        <v-row>
          <v-col class="ma-0 py-0 pt-6" cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="prontuarioMedico"
              rules="size:20480"
            >
              <v-file-input
                v-model="fields.prontuarioMedico"
                chips
                filled
                prepend-icon="mdi-file-upload-outline"
                :error-messages="errors"
                :show-size="true"
                :truncate-length="$vuetify.breakpoint.xsOnly ? 20 : 50"
                placeholder="Click para inserir uma foto ou arquivo PDF (máx. 20 MB)"
                accept="image/*, .pdf"
              />
            </validation-provider>
          </v-col>
          <v-col
            v-if="$i18n.i18next.language === 'pt_br'"
            class="ma-0 py-0 pt-2"
            cols="12"
          >
            <v-text-field
              v-model="fields.numeroSus"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[0-9-]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              label="Número do SUS"
            />
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form group-label="Médico Particular">
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <v-text-field
              v-model="fields.nomeMedico"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              label="Nome"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="foneMedico"
              :rules="{ fone: /\(\d\d\)\s\d{4,5}-\d{4}/ }"
            >
              <v-text-field
                v-model="fields.foneMedico"
                v-mask="['(##) #####-####', '(##) ####-####']"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                label="Telefone"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="4">
            <v-text-field
              v-model="fields.empresaMedico"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.0-9-]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              label="Empresa/Compainha/Divisão"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12">
            <v-text-field
              v-model="fields.observacao"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              label="Observação"
            />
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { size, regex } from "vee-validate/dist/rules";
import { updateData, uploadFile } from "@/services";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data: () => ({
    fields: {
      prontuarioMedico: null,
      numeroSus: "",
      nomeMedico: "",
      foneMedico: "",
      empresaMedico: "",
      observacao: "",
    },
  }),
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };
      this.fields.prontuarioMedico = null;
      this.fields.nomeMedico = this.$options.filters.toPT_BRCapitalize(
        this.fields.nomeMedico
      );
      this.fields.empresaMedico = this.$options.filters.toPT_BRCapitalize(
        this.fields.empresaMedico
      );
      this.fields.observacao = this.$options.filters.capitalize(
        this.fields.observacao,
        { onlyFirstLetter: true }
      );
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("size", {
      ...size,
      message: this.$t("arquivo_menos_de_20MB"),
    });

    extend("fone", {
      ...regex,
      message: this.$t("telefone_invalido"),
    });
  },
  methods: {
    onSave() {
      const fields = JSON.parse(JSON.stringify(this.fields));
      if (this.fields.prontuarioMedico) {
        uploadFile(
          this,
          "tagFuncionario",
          this.fields.prontuarioMedico,
          "prontuarioMedico",
          (data) => {
            updateData(this, "tagFuncionario", {
              ...fields,
              ...data,
            });
          }
        );
      } else {
        this.fields.prontuarioMedico = this.data.prontuarioMedico;
        updateData(this, "tagFuncionario", this.fields);
      }
    },
  },
};
</script>

<style scoped></style>
